import { atom } from 'recoil';

export interface RegistrationSelection {
    readonly sopUid: string;
    readonly imageSeriesUid?: string;
}

export const selectedRegistrationState = atom<RegistrationSelection | null>({
    key: 'selectedRegistration',
    default: null,
});

export const deformationUnderReviewState = atom<RegistrationSelection | null>({
    key: 'deformationUnderReview',
    default: null,
});
